module.exports = __webpack_public_path__ + "media/img/pages/companies/ewp-2810d06087238dc7e2eca7d4ceaa606d.jpg";